import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class CameraGroupService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	create(cameraGroup, callback) {
		const url = "/ecosystem/api/cameraGroups";
		const body = JSON.stringify(cameraGroup);
		this._restClient.exec_post(url, body, callback);
	}

	update(groupId, update, callback) {
		const url = `/ecosystem/api/cameraGroups/${groupId}`;
		const body = JSON.stringify(update);
		this._restClient.exec_put(url, body, callback);
	}

	delete(groupId, callback) {
		const url = `/ecosystem/api/cameraGroups/${groupId}`;
		this._restClient.exec_delete(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/cameraGroups";
		this._restClient.exec_get(url, callback);
	}

	subscribeCameraGroups(callback) {
		const args = {
			filterType: "all"
		};
		this._rc.subscribe("ecosystem", "/cameraGroups", args, (msg) => {
			const response = JSON.parse(msg);
			if (response && callback) {
				callback(null, response);
			}
		});
	}

	searchForPinning(value, callback) {
		const url = `/ecosystem/api/cameraGroups/searchPinnable/${value}`;
		this._restClient.exec_get(url, callback);
	}

	bulkUpdate(update, callback) {
		const url = "/ecosystem/api/cameraGroups/bulkUpdate";
		const body = JSON.stringify(update);
		this._restClient.exec_put(url, body, callback);
	}
}
